import Pane from 'components/Common/Pane'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'components/Luxkit/Button/TextButton'
import zIndex from 'styles/tools/z-index'
import WalledContent from 'components/Common/WalledContent'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { useAppDispatch } from 'hooks/reduxHooks'
import { accountAccessShowLogin } from 'actions/UiActions'

const FooterWrapper = styled(Pane)`
  bottom: 0;
  box-shadow: ${(props) => props.theme.shadow.top.small};
  display: flex;
  flex-direction: column;
  padding: ${rem(20)} ${rem(16)};
  position: fixed;
  width: 100vw;
  z-index: ${zIndex.stickyFooter};

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const ContentContainer = styled.div`
  display: flex;
  gap: ${rem(12)};
  justify-content: space-between;
  align-items: end;
`

const AuthWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & > * + * {
    margin-left: ${rem(16)};
  }
`

const ButtonsWrapper = styled.div`
  flex-shrink: 0;

  & > * + * {
    margin-left: ${rem(8)};
  }
`

const MobileSignUp = styled(TextButton)`
  display: inline-flex;

  ${mediaQueryUp.tablet}{
    display: none;
  }
`

const StyledPackageOptionsButton = styled(TextButton)`
  margin-left: auto;
`

interface Props {
  callToActionCopy?: string
  onCTAClick: () => void
  walledGarden?: boolean
}

function OfferPageStickyFooter(props: PropsWithChildren<Props>) {
  const {
    callToActionCopy = 'View options',
    onCTAClick,
    walledGarden = false,
    children,
  } = props
  const dispatch = useAppDispatch()

  return (
    <FooterWrapper >
      <ContentContainer>
        {children}
        <WalledContent enforced={walledGarden} wall={(
          <AuthWrapper>
            <BodyText variant="medium" weight="semi-bold">Join now to view member prices</BodyText>
            <ButtonsWrapper>
              <TextButton kind="secondary" onClick={() => dispatch(accountAccessShowLogin())}>
                Log In
              </TextButton>
              <MobileSignUp kind="primary" onClick={() => dispatch(accountAccessShowLogin())}>
                Sign up
              </MobileSignUp>
            </ButtonsWrapper>
          </AuthWrapper>
          )}>
          <StyledPackageOptionsButton kind="primary" onClick={onCTAClick}>
            {callToActionCopy}
          </StyledPackageOptionsButton>
        </WalledContent>
      </ContentContainer>
    </FooterWrapper>
  )
}

export default OfferPageStickyFooter
